export default "__VITE_ASSET__DQQxUEc$__"